/**
 * @generated SignedSource<<66cebf696aa10d3acaed41aac8467628>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { Fragment, ReaderFragment } from 'relay-runtime';
import { FragmentRefs } from "relay-runtime";
export type EditBrandInfo_brand$data = {
  readonly businessPageGoogle: string | null | undefined;
  readonly businessPageYelp: string | null | undefined;
  readonly category: {
    readonly id: string;
    readonly name: string;
  } | null | undefined;
  readonly id: string;
  readonly igName: string | null | undefined;
  readonly name: string;
  readonly phone: string | null | undefined;
  readonly website: string | null | undefined;
  readonly " $fragmentType": "EditBrandInfo_brand";
};
export type EditBrandInfo_brand$key = {
  readonly " $data"?: EditBrandInfo_brand$data;
  readonly " $fragmentSpreads": FragmentRefs<"EditBrandInfo_brand">;
};

const node: ReaderFragment = (function(){
var v0 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "id",
  "storageKey": null
},
v1 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "name",
  "storageKey": null
};
return {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "metadata": null,
  "name": "EditBrandInfo_brand",
  "selections": [
    (v0/*: any*/),
    (v1/*: any*/),
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "igName",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "phone",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "website",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "concreteType": "CategoryType",
      "kind": "LinkedField",
      "name": "category",
      "plural": false,
      "selections": [
        (v0/*: any*/),
        (v1/*: any*/)
      ],
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "businessPageYelp",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "businessPageGoogle",
      "storageKey": null
    }
  ],
  "type": "BrandType",
  "abstractKey": null
};
})();

(node as any).hash = "fd5de8756bf97a5d94cbb38f4f7d1324";

export default node;
